import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import { ProfileBoxMessagesIndicator } from "../profile-box-messages-indicator.component";

@observer
export class ChallengesIndicator extends OrbitComponent {
    public render() {
        return (
            <ProfileBoxMessagesIndicator
                hasAwaitingMessages = {this.services.user.hasActiveChallenges}
                className = 'cy-challenges-button-container'
                iconSet = "Challenges"
                text = {this.services.translation.translate("MY_CHALLENGES")}
                onClick={() => {
                    this.services.externalLinks.openMyAccount({tabId: 16});
                }}
            />
        );
    }
}
